import { AfterViewInit, Component, OnDestroy, OnInit } from '@angular/core';

@Component({
  selector: 'app-pdf-viewer',
  templateUrl: './pdf-viewer.component.html',
  styleUrls: ['./pdf-viewer.component.scss']
})
export class PdfViewerComponent implements OnInit, AfterViewInit, OnDestroy {

  pdfSource= (window.location.origin.includes('localhost'))?
              "../../assets/MDCPA_VAB Agent Exchange Portal User Manual.pdf":
                (window.location.href.includes("_Multi_Test")?  // if in test  
                "/PAOnlineTools/Registration_Portal_Client_Multi_Test/assets/MDCPA_VAB Agent Exchange Portal User Manual.pdf": //load test PDF
                "/PAOnlineTools/RegistrationPortalClient/assets/MDCPA_VAB Agent Exchange Portal User Manual.pdf");

  constructor() {
  }

  ngOnInit(): void {
  }

  private pdfContainerObserver?: MutationObserver;

  ngAfterViewInit(): void {
    this.setPdfContainerAccessibility();
    this.pdfContainerObserver = new MutationObserver(() => this.setPdfContainerAccessibility());
    this.pdfContainerObserver.observe(document.body, { childList: true, subtree: true });
  }

  ngOnDestroy(): void {
    if (this.pdfContainerObserver) {
      this.pdfContainerObserver.disconnect();
      this.pdfContainerObserver = undefined;
    }
  }

  private setPdfContainerAccessibility(): void {
    const container = document.querySelector('.ng2-pdf-viewer-container') as HTMLElement | null;
    if (!container) {
      return;
    }

    if (container.getAttribute('role') !== 'region') {
      container.setAttribute('role', 'region');
    }
    if (!container.hasAttribute('tabindex')) {
      container.setAttribute('tabindex', '0');
    }
    if (!container.hasAttribute('aria-label')) {
      container.setAttribute('aria-label', 'PDF document viewer');
    }
  }

}
